import { render, staticRenderFns } from "./AddTextButton.vue?vue&type=template&id=43f364e7&scoped=true"
import script from "./AddTextButton.vue?vue&type=script&lang=js"
export * from "./AddTextButton.vue?vue&type=script&lang=js"
import style0 from "./AddTextButton.vue?vue&type=style&index=0&id=43f364e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f364e7",
  null
  
)

export default component.exports